import React from 'react';
import { Shield, Clock, DollarSign, Lock, Zap, Heart, CheckCircle2 } from 'lucide-react';
import { whyUseFeatures } from '../data/mockData';

const iconMap = {
  Shield: Shield,
  Clock: Clock,
  DollarSign: DollarSign,
  Lock: Lock,
  Zap: Zap,
  Heart: Heart
};

const VETTING_CHECKS = [
  'Current real estate licence verified',
  'Recent sales in your suburb or nearby',
  'Verified client reviews and complaint check',
  'Clear, upfront fees and marketing costs',
];

const WhyUse = () => {
  return (
    <section id="why-use" className="section-container section-alt">
      <div className="section-content">
        <div className="section-header">
          <h2 className="section-title">Why Use FindMeAgent?</h2>
          <p className="section-description">
            Get matched with pre-vetted local experts, so you compare only agents worth your time
          </p>
        </div>

        <div className="vetting-block" data-testid="vetting-block">
          <figure className="vetting-media">
            <img
              src="/images/lifestyle/family-sold-sign.jpg"
              alt="Happy family celebrating in front of their home with a SOLD sign"
              loading="lazy"
              width="1200"
              height="805"
              data-testid="vetting-image"
            />
            <figcaption className="vetting-caption">Sold with a FindMeAgent-matched agent</figcaption>
          </figure>
          <div className="vetting-copy">
            <span className="vetting-eyebrow">Our vetting promise</span>
            <h3 className="vetting-title">What "pre-vetted" actually means</h3>
            <p className="vetting-text">
              We don't list every agent who asks. Before an agent can be introduced to you, our team checks:
            </p>
            <ul className="vetting-list">
              {VETTING_CHECKS.map((item) => (
                <li key={item} className="vetting-item">
                  <CheckCircle2 size={20} className="vetting-check" aria-hidden="true" />
                  <span>{item}</span>
                </li>
              ))}
            </ul>
            <p className="vetting-footnote">
              You receive a shortlist of 2 to 3 agents, usually within one business day. Free, and no obligation to sign with anyone.
            </p>
          </div>
        </div>

        <div className="features-grid">
          {whyUseFeatures.map((feature) => {
            const IconComponent = iconMap[feature.icon];
            return (
              <div key={feature.id} className="feature-card">
                <div className="feature-icon-wrapper">
                  <IconComponent className="feature-icon" size={28} />
                </div>
                <h3 className="feature-title">{feature.title}</h3>
                <p className="feature-description">{feature.description}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default WhyUse;
